import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-suivi-reco',

  template: `
    <iframe [src]="trackingUrl | safeObjUrl" style="position: relative; height: 100%;width: 100%;" frameborder="0"></iframe>`
})
export class SuiviRecoComponent implements OnInit {

  @Input('recoId') recoId;
  trackingUrl: any;
  ngOnInit(): void {
    this.trackingUrl = 'https://www.laposte.fr/professionnel/outils/suivre-vos-envois?code=' + this.recoId;
  }
}
